import controlDate from './index.js';

const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

const SET_PRODUCTS = (state, products) => {
  state.outDated= false;
  state.cmsProducts = products;
};

const SET_SEARCH = (state, search) => {
  state.search = search;
}

const INVALIDATE = (state) => {
  state.outDated= true;
}

const SET_TOTAL_PAGES = (state, totalPages) => {
  state.totalPages= totalPages;
}

const SET_CURRENT_PAGE = (state, currentPage) => {
  state.currentPage= currentPage;
}

const SET_TOTAL_PRODUCTS = (state, totalProducts) => {
  state.totalProducts = totalProducts
}

const UPDATE_PRODUCT = (state, product) => {
  const index = _.findIndex(state.cmsProducts, p => p.id === product.id);
  Object.assign(state.cmsProducts[index], product);
}

const SET_PUBLISH_IND = (state, {id, publishInd}) => {
  const index = _.findIndex(state.cmsProducts, p => p.id === product.id);
  state.cmsProducts[index].published = publishInd;
}

export default {
  SET_LOADING,
  SET_PRODUCTS,
  SET_SEARCH,
  INVALIDATE,
  SET_TOTAL_PAGES,
  SET_CURRENT_PAGE,
  SET_TOTAL_PRODUCTS,
  UPDATE_PRODUCT,
  SET_PUBLISH_IND
};
